import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface OwnProps {
	enable?: boolean;
	size?: number;
}

interface Props extends OwnProps, WithStyles<typeof styles> {	
}

interface State {
	showIndicator: boolean;
}

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			showIndicator: false,
		};
	}
	timer: NodeJS.Timeout | null = null;

	componentDidMount() {
		if (this.props.enable) {
			this.setState({showIndicator: true});
		}
		this.timer = setTimeout(this.enableIndicator, 1000);
	}

	componentWillUnmount() {
		if (this.timer) {
			clearTimeout(this.timer);
		}
	}

	enableIndicator = () => {
		this.setState({ showIndicator: true });
	};

	render() {
		const { size } = this.props;
		return this.state.showIndicator ? (
			<div className={this.props.classes?.container}>
				<Mui.CircularProgress color="secondary" size={size ? size : undefined}/>
			</div>
		) : null;
	}
}

export const LoadingIndicator = withStyles(Component, styles);
